import Cookies from "js-cookie";

export function getRoleToken() {
  return Cookies.get("_ym_jwltone_10021");
}

export function setRoleToken(token) {
  return Cookies.set("_ym_jwltone_10021", token);
}
